import initMarquee from '../libs/initMarquee';

document.addEventListener('DOMContentLoaded', (e) => {
  const ticker = document.querySelector('[data-ticker]');
  initMarquee(ticker);
});
